import React from 'react';
import { useI18n } from '@/i18n/LanguageContext';
import { useAuth } from '@/contexts/AuthContext';
import { Globe } from 'lucide-react';
import { Lang } from '@/data/constants';

const LanguageToggle: React.FC<{ compact?: boolean }> = ({ compact }) => {
  const { lang, setLang } = useI18n();
  const { profile, updateProfile } = useAuth();

  const choose = (l: Lang) => {
    setLang(l);
    if (profile && profile.preferred_language !== l) updateProfile({ preferred_language: l });
  };

  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white p-1 shadow-sm">
      {!compact && <Globe className="ml-1.5 h-3.5 w-3.5 text-slate-400" aria-hidden />}
      {(['en', 'es'] as Lang[]).map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => choose(l)}
          aria-label={l === 'en' ? 'English' : 'Español'}
          aria-pressed={lang === l}
          className={`rounded-full px-2.5 py-1 text-xs font-bold uppercase tracking-wide transition-colors ${
            lang === l ? 'bg-slate-900 text-white' : 'text-slate-500 hover:text-slate-900'
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;
